import { call, put } from 'redux-saga/effects';

import { fetchEntityJurisdiction } from '@api/entityJurisdictions';
import { entityJurisdictionItemModel } from '@models/entityJurisdictions';
import { entityJurisdictionInfoSuccess } from '@store/entityJurisdictions/entityJurisdictionsDetail/entityJurisdictionInfo/entityJurisdictionInfo.reducer';

export const fetchEntityJurisdictionInfoSaga = function* ({ payload }) {
  const { entityJurisdictionId } = payload;
  const response = yield call(fetchEntityJurisdiction, entityJurisdictionId, true);
  const model = yield call(entityJurisdictionItemModel, response);
  yield put(entityJurisdictionInfoSuccess(model));
};
